import FilterComponent from '../../components/charts/filter/ChartFilter';
import getChartType from '../../utils/helpers/getChartType';
import useSelectData from '../../hooks/data/useSelectData';
import ChartTitle from '../charts/title/ChartTitle';
import React, { useState, useEffect } from 'react';
import { config } from '../../config/Constants';
import './css/reportChartController.css';
import Legend from './legendController';
import { Button } from '@mui/material';
import Axios from 'axios';

const Chart = ({request}) => { 
  const [currentFilterNOptions, setCurrentFilterNOptions] = useState(null);
  const [chartObjectTemp, setChartObjectTemp] = useState({});
  const [chartLegend, setChartLegend] = useState(null);
  const [chartComponent, setChartComponent] = useState(null);
  const [reportTypeValue, setReportTypeValue] = useState(request.defaultFilterOptions.key);  
  const [selectedFilter, setSelectedFilter] = useState({ "Report Type": reportTypeValue });

  // HOOKS
  const reportName = useSelectData({ selectValues: 'REPORT_NAME',  tableName: 'reports.REPORTS', 
    whereField: 'ID',  whereValue: request.reportId,
  });

  const reportDesc = useSelectData({
    selectValues: 'CONTENT',  tableName: 'dbo.REPORT_DESCRIPTION', 
    whereField: 'ID',  whereValue: request.reportId,
  });

  const reportType = useSelectData({
    selectValues: 'FILTER_NAME AS OPTION_NAME',  tableName: 'CHART.FILTER_TYPE', 
    whereField: 'FK_REPORT_ID',  whereValue: request.reportId
  });

  const filterReportType = [{
    FILTER_NAME: "Report Type",
    options: reportType.map(item => ({ OPTION_NAME: item.OPTION_NAME}))
  }];

  const filters = useSelectData({
    selectValues: 'FILTER_ID, FILTER_NAME',  tableName: 'CHART.CHART_FILTERS_VW', 
    whereField: 'TYPE_FILTER',  whereValue: reportTypeValue
  });

  const options = useSelectData({
    selectValues: 'FILTER_ID, OPTION_NAME ', tableName: 'CHART.CHART_OPTIONS_VW', 
    whereField: 'TYPE_FILTER',  whereValue: reportTypeValue
  });


  const mergedFilterOptions = filters.map(filter => ({
    ...filter, 
    options: options.filter(option => option.FILTER_ID === filter.FILTER_ID)
  }));

  useEffect (() => {
    setChartLegend(chartObjectTemp.legend);
    getChartComponent()
  }, [chartObjectTemp])

  const getChartObject = async () => {
    if (request.customerName !== 'GTMS-CP') {
    const currentSelectedFilterOptions = currentFilterNOptions == null ? request.defaultFilterOptions : currentFilterNOptions;
  
    const formattedFilters = Object.fromEntries(
      Object.entries(currentSelectedFilterOptions).map(([key, value]) => 
        key === "Report Type" ? ["key", value] : [key, value]
      )
    );

    const result = await Axios.get(config.url.GET_UNIVERSAL_REPORT, {
      params: {
        companyName: request.customerName,
        reportName: request.reportName,
        reportId: request.reportId,
        filterOptions: formattedFilters,
        parentComponent: 'reportChartController'
      }      
    });
    setChartObjectTemp(result.data.dataResults)
  }
    if (request.customerName === 'GTMS-CP') {
      console.log(request.defaultFilterOptions)
      const response = await Axios.get(config.url.GET_REPORT, {
        params: {
          reportName: 'laneviewheatmap',
          companyName: request.customerName,
        },
      });
      setChartObjectTemp(response.data.report[0])
    }
  };

  const getChartComponent = async () => {
    const returnChart = await getChartType({
      ...chartObjectTemp, 
      chartInfo: [{TYPE: chartObjectTemp.chartType}], 
    });
    setChartComponent(returnChart)
  };

  const handleFilterChange = (filterName, selectedValue) => {
    setSelectedFilter(prevFilters => {
      let updatedFilters;
  
      if (filterName === "Report Type") {
        setReportTypeValue(selectedValue); 
        updatedFilters = { "Report Type": selectedValue };
      } else {
        updatedFilters = { ...prevFilters, [filterName]: selectedValue };
      }
      setCurrentFilterNOptions(updatedFilters);
      return updatedFilters;
    });
  };

  useEffect(() => { getChartObject(); }, []);
  const reportTitle = reportName.length > 0  ? reportName.map(item => item.REPORT_NAME) : null;
  const reportDescription = reportDesc.length > 0  ? reportDesc.map(item => item.CONTENT) : null;
  const handleReset = () => { window.location.reload(); }
  const handleSubmit = () => { getChartObject() }
  
  return (
    <div className="universalChartComponent">
      <div className='universalChartTop'>
        <div className='universalChartComponentTitle'>
          <ChartTitle chartTitle={reportTitle} chartDescription={reportDescription} />
        </div>
      </div>
      <div className='universalChartComponentLower'>
        <div className="universalChartComponentLeft" >
          <div className="chartComponent">
            {chartComponent}
          </div>
        </div>
        {(mergedFilterOptions != null || chartLegend != null) && (
          <div className="universalChartComponentRight">
            {mergedFilterOptions && (
              <div className="universalChartFilter">
                <h3>Filter Options:</h3>
                <FilterComponent 
                  filters={filterReportType} 
                  handleFilterChange={handleFilterChange} 
                  selectedFilters={selectedFilter} 
                />
                <FilterComponent 
                  filters={mergedFilterOptions} 
                  handleFilterChange={handleFilterChange} 
                  selectedFilters={selectedFilter} 
                />
                <div className="universalChartReset">
                  <Button variant='outlined' onClick={handleSubmit}>Apply Filter</Button>
                </div>
                <div className="universalChartReset">
                  <Button variant='outlined' onClick={handleReset}>Reset Filter</Button>
                </div>
              </div>
            )}
            {chartLegend && (
              <div className="universalChartLegend">
                <Legend 
                  type="GRADIENT" 
                  colorRange={chartLegend.colorRange}
                  legendMin={chartLegend.legendMin}
                  legendMax={chartLegend.legendMax}
                />
              </div>            
            )}
          </div>
        )}
      </div>
    </div>
  );	
}

export default Chart